'use client'

import React from 'react';
import styled from 'styled-components';
import {usePathname} from "next/navigation";
import Link from "next/link";
import {hover, Transition} from "@/styles/globalStyleVars";
import parser from "html-react-parser";

const StickyButton = ({link, img, svg, text}) => {

    const location = usePathname();

    return (
        <StyledBtn className={`dc-btn`}
        >
            <Link id="imSticky" data-magnetism  href={'tel:09602333500'}>
                {
                    svg ?
                        parser(svg)
                        :
                        img ?
                            <img src={img} alt={text}/>
                            : ''
                }

            </Link>
        </StyledBtn>
    )
};

const StyledBtn = styled.div`

    position: fixed;
    right: 50px;
    bottom: 100px;
    z-index: 999;

    @media(max-width: 767px){
        right: 15px;
        bottom: 80px;
    }
    
    svg{
        height: 50px;
        width: 50px;
    }
    a {
        .circle {
            transition: 0.7s all ${Transition};
        }

        &:hover {
            .circle{
                r: 20px;
            }
        }
    }
`;


export default React.memo(StickyButton);
